import {Area} from "../enums/area";
import {Route} from "../../../common/enums/route";
import {RouteHelper} from "../../../common/helpers/routeHelper";

function loadView(view) {
  return () => import(`../components/${view}.vue`);
}

const routes = [
  {
    name: Area.listView,
    path: RouteHelper.path({route: Route.listView}),
    components: {
      default: loadView('view-list-view'),
      secondaryHeader: loadView('list-view-secondary-header'),
    },
  },
  {
    name: Area.listViewPreview,
    path: RouteHelper.path({route: Route.previewListView}),
    components: {
      default: loadView('view-list-view'),
      secondaryHeader: loadView('list-view-preview-secondary-header'),
    },
    props: {default: {preview: true}},
  },
  {
    name: Area.entityDashboardListView,
    path: RouteHelper.path({route: Route.entityDashboardListView}),
    components: {
      default: loadView('view-list-view'),
    },
  },
  {
    name: Area.detailView,
    path: RouteHelper.path({route: Route.detailView}),
    components: {
      default: loadView("view-detail-view"),
      secondaryHeader: loadView('detail-view-secondary-header'),
    },
    children: [
      {
        name: Area.detailViewFormList,
        path: 'form_list/:content_element_id',
        breadcrumbText: "Form List"
      }
    ]
  },
  {
    name: Area.detailViewEditMode,
    path: RouteHelper.path({route: Route.detailViewEditMode}),
    components: {
      default: loadView("view-detail-view"),
      secondaryHeader: loadView('detail-view-secondary-header'),
    },
    props: {default: {isInEditMode: true}, secondaryHeader: {isInEditMode: true}},

  },
  {
    name: Area.detailViewPreview,
    path: RouteHelper.path({route: Route.previewDetailView}),
    components: {
      default: loadView("view-detail-view"),
      secondaryHeader: loadView('detail-view-preview-secondary-header'),
    },
    props: {default: {preview: true}},
  },
  {
    name: Area.previewDetailViewListView,
    path: RouteHelper.path({route: Route.previewDetailViewListView}),
    components: {
      default: loadView("view-list-view"),
      secondaryHeader: loadView('detail-view-preview-secondary-header'),
    },
    props: {default: {preview: true}},
  },
  {
    name: Area.detailViewFileAttachments,
    path: RouteHelper.path({route: Route.detailViewFileAttachments}),
    components: {
      default: loadView('detail-view-show-all-attachments'),
      secondaryHeader: loadView('detail-view-secondary-header')
    }
  },
  {
    name: Area.userDashboardDetailView,
    path: RouteHelper.path({route: Route.userDashboardDetailView}),
    components: {
      default: loadView('view-detail-view'),
    },
  },
];

export default routes;